export default function TechnicalRow({
  leftLabel,
  leftValue,
  leftSubtitle,
  leftAdditionalInfo,
  leftMeasurements,
  rightLabel,
  rightValue,
  rightAdditionalInfo,
  rightMeasurements,
}) {
  return (
    <tr className="border-b border-gray-200 last:border-b-0 block sm:table-row">
      {/* Left Column */}
      <td className="p-4 border-b sm:border-b-0 sm:border-r border-gray-200 w-full sm:w-1/2 align-top block sm:table-cell">
        <div className="space-y-2">
          <div className="text-sm text-gray-600 font-semibold">{leftLabel}</div>
          <div className="font-semibold text-[#2F4B7C]">
            {leftValue}
            {leftSubtitle && <span className="text-sm text-gray-500 ml-1">{leftSubtitle}</span>}
          </div>
          {leftAdditionalInfo && (
            <div className="space-y-1 mt-3">
              {leftAdditionalInfo.map((info, index) => (
                <div key={index} className="flex justify-between items-center">
                  <span className="text-sm  text-gray-600 text-left">{info.label}</span>
                  <span className="font-semibold text-[#2F4B7C] text-sm">{info.value}</span>
                </div>
              ))}
            </div>
          )}
          {leftMeasurements && (
            <div className="space-y-1 mt-3">
              {leftMeasurements.map((measurement, index) => (
                <div key={index} className="flex justify-between items-center">
                  <span className="text-sm text-gray-600 text-left">{measurement.label}</span>
                  <span className="font-semibold text-sm text-[#2F4B7C]">{measurement.value}</span>
                </div>
              ))}
            </div>
          )}
        </div>
      </td>

      {/* Right Column */}
      <td className="p-4 w-full sm:w-1/2 align-top block sm:table-cell">
        <div className="space-y-2">
          <div className="text-sm text-gray-600 font-semibold">{rightLabel}</div>
          {rightValue && <div className="font-semibold text-[#2F4B7C] text-sm">{rightValue}</div>}
          {rightAdditionalInfo && (
            <div className="space-y-1 mt-3">
              {rightAdditionalInfo.map((info, index) => (
                <div key={index} className="flex justify-between items-center">
                  <span className="text-sm text-gray-600 text-left">{info.label}</span>
                  <span className="font-semibold text-sm text-[#2F4B7C] text-end">{info.value}</span>
                </div>
              ))}
            </div>
          )}
          {rightMeasurements && (
            <div className="space-y-1 mt-3">
              {rightMeasurements.map((measurement, index) => (
                <div key={index} className="flex justify-between items-center">
                  <span className="text-sm text-gray-600">{measurement.label}</span>
                  <span className="font-semibold text-[#2F4B7C]">{measurement.value}</span>
                </div>
              ))}
            </div>
          )}
        </div>
      </td>
    </tr>
  )
}
